// Auto-generated from icon.json
export default {
  "tagName": "ui-icons"
};
